// src/utils/wsUrls.js
export const wsBaseURL = "wss://ds.playblock.io";

export const wsEndpoints = {
  integration: `${wsBaseURL}/sub?id=playnance_bridge_notifications_int`,
  production: `${wsBaseURL}/sub?id=playnance_bridge_notifications`,
  globalProduction: `${wsBaseURL}/sub?id=playnance_bridge_notifications_global`,
};
